export default __webpack_public_path__ + "static/char-s-61-zh-Hans-322d4f1808192ac183302503774dd888.png";